import window from 'window-or-global';
import initCustomToolbarComponents from './custom-toolbar-components';
import getTablePicker from '../aeTable/atlassian-table-picker';
import eventDelegator from '../resources/event/tinymce-event-delegator.js';
import tableToolbarEvents from './table-toolbar-events';
import adg3Plugin from './adg3-plugin';

export function addTableToolbar() {
	const Delegator = eventDelegator(window.tinymce);
	Delegator.addEventsForComponent('TableToolbar', tableToolbarEvents);
}

export function customToolbar() {
	const plugger = adg3Plugin;

	initCustomToolbarComponents();
	getTablePicker();
	window.tinymce.create('tinymce.plugins.customtoolbar', plugger());
	window.tinymce.PluginManager.add('customtoolbar', window.tinymce.plugins.customtoolbar);
}

export function customToolbarWRM() {
	return [
		'wr!confluence.web.resources:legacy-editor-global-AVOID-IF-POSSIBLE',
		'wr!confluence.web.resources:hint-manager',
	];
}
